<template>
  <div class="mod-config" style="height: 100% ">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;">
        <el-button @click="deviceQuery()" :type="buttonequip">设备</el-button>
        <el-button @click="companyQuery()" :type="buttondayenterprise">企业</el-button>
        <el-button @click="areaQuery()" :type="buttonregion">区域</el-button>
      </el-form-item>
      <el-form-item style="float: left;margin-left: 6px;" label="选择时间：">
        <el-date-picker :picker-options="dataForm.pickerOptions" v-model="dataForm.dateStr" type="year" format="yyyy"
          value-format="yyyy-01-01" placeholder="选择年份">
        </el-date-picker>
      </el-form-item>
      <el-form-item style="float: left;margin-left: 6px;" :label="labelNew +'：'">
        <template>
          <el-input v-model="value" @click.native="handleClick" placeholder="输入关键字进行过滤" style="width: 300px;"
            clearable></el-input>
          <!--          <el-input placeholder="输入关键字进行过滤" v-model="filterText" v-show="isiptShow"></el-input>-->
          <el-tree id="el_Tree" class="filter-tree" :data="hTree" :check-strictly="true"
            :filter-node-method="filterNode" ref="tree" @node-click="handleCheckChange" v-show="isiptShow">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <!--给设备追加图标-->
              <i v-if="data.deviceStatus == 1" class="iconfont"><img src="../../assets/img/yq01.png" alt="" width="16"
                  height="16"></i>
              <i v-if="data.deviceStatus == 2" class="iconfont"><img src="../../assets/img/yq02.png" alt="" width="16"
                  height="16"></i>
              <i v-if="data.deviceStatus == 3" class="iconfont"><img src="../../assets/img/yq03.png" alt="" width="16"
                  height="16"></i>
              <i v-if="data.deviceStatus == 4" class="iconfont"><img src="../../assets/img/yq04.png" alt="" width="16"
                  height="16"></i>
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </template>
      </el-form-item>
      <el-button @click="getDataList()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button type="success" @click="tempExcel()" v-show="isShow">导出Excel</el-button>
        <el-button type="success" @click="detailExcel()" v-show="isShowExcel">导出详情Excel</el-button>
      </el-form-item>
    </el-form>
    <div class="list-div" @click="isiptShow = false">
      <p class="list-p" v-if="dataList == null || dataList.length <= 0 ">
        <i class="el-icon-warning"></i>
        {{ msg }}
      </p>
      <el-table v-for="(item,index) in dataList" :data="item.table" :tableId="index" :key="index"
        :span-method="arraySpanMethod" border stripe v-loading="dataListLoading" :cell-style="{borderColor:'#333'}"
        :header-cell-style="{background:'#172556',color:'#fff'}" style="width: 100%;" height="calc(100% - 0px)"
        placement="top" v-show="detaildialoglist">
        <el-table-column fixed="left" prop="companyName" header-align="center" align="center" label="企业名称">
        </el-table-column>
        <el-table-column fixed="left" prop="recordTime" header-align="center" align="center" label="报表日期"
          :formatter="dateFormat">
        </el-table-column>
        <el-table-column fixed="left" prop="deviceName" header-align="center" align="center" label="设备名称">
        </el-table-column>
        <el-table-column prop="channelName" header-align="center" align="center" label="监测因子">
        </el-table-column>
        <el-table-column prop="maxValues" header-align="center" align="center" label="最大值">
        </el-table-column>
        <el-table-column prop="minValues" header-align="center" align="center" label="最小值">
        </el-table-column>
        <el-table-column prop="avgValue" header-align="center" align="center" label="平均值">
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="detailsHandle(scope.row.deviceId)"><i class="el-icon-data-analysis"
                style="font-size: 18px;vertical-align: text-bottom;"></i>查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-table :key="Math.random()" :data="dataFormrl" :span-method="arraySpanMethodnew" stripe border
          :header-cell-style="{background:'#172556',color:'#fff'}" style="width: 100%;display: none" placement="top"
          v-show="detaildialog">
          <el-table-column fixed="left" prop="companyName" header-align="center" align="center" label="企业名称1">
          </el-table-column>
          <el-table-column fixed="left" prop="deviceName" header-align="center" align="center" label="设备名称">
          </el-table-column>
          <el-table-column fixed="left" prop="recordTime" header-align="center" align="center" width="150"
            label="监测时间/监测因子">
          </el-table-column>
          <el-table-column v-for="(item, index) in tableHead" :key="index" header-align="center" align="center"
            :label="item.title" :prop="item.field">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {excel, formatDate} from "@/utils";
export default {
  data() {
    return {
      dataForm: {
        dateFromStr: '',
        dateToStr: '',
        companyId: "",
        dateEnum: '',
        deviceId: "",
        areaId: "",
        dateStr: '',
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        }
      },
      isShow:false,
      isShowExcel: false,
      dataList: [],
      value: '',
      options: [],
      dataFormrl:[],
      tableHead:[],
      labelNew: "选择设备",
      msg: '请选择设备',
      //区分企业-777/区域-888/设备-999
      type: -999,
      buttonequip: '',
      buttondayenterprise: '',
      buttonregion: '',
      hTree: [],
      isiptShow:false,
      detaildialog: false,
      detaildialoglist:true,
      dcxq:""
    }
  },
  created() {
    //动态设置默认时间
    this.dataForm.dateStr = this.$moment(new Date()).format("yyyy-01-01")
    this.deviceQuery()
  },
  watch: {
    value(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    detailsHandle(deviceId){
      this.dcxq = deviceId;
      this.detaildialoglist = false;
      this.detaildialog = true;
      //时间条件
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr
        this.dataForm.dateToStr = this.$moment(this.dataForm.dateFromStr).add(1, 'years').format("yyyy-MM-DD")
      } else {
        this.msg = "请选择时间";
        this.$message.warning(this.msg)
        return
      }
      this.$http({
        url: this.$http.adornUrl('/record/detail'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'deviceId': deviceId,
          'dateFromStr': this.dataForm.dateFromStr,
          'dateToStr': this.dataForm.dateToStr,
          'dateEnum': this.dateEnum,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.isShow = false;
          this.isShowExcel = true;
          this.tableHead = data.data.head;
          this.dataFormrl = data.data.rows;
        }
      })
    },
    handleClick(){
      this.isiptShow = true;
    },
    //节点选中状态发生变化时的回调
    handleCheckChange(data) {
      if (data.deviceId && this.type == -999) {
        this.value = data.label
        this.dataForm.deviceId = data.deviceId
      } else if (data.companyId  && this.type == -777) {
        this.value = data.label
        this.dataForm.companyId = data.companyId
      }else if (data.areaId  && this.type == -888) {
        this.value = data.label
        this.dataForm.areaId = data.areaId
      }
      if (data.children.length == 0) {
        this.isiptShow = false
      }
    },
    //节点过滤
    filterNode(value, data) {
      if (this.buttonequip == 'primary') {
        if (!value) return true;
        if (!data.label) return false;
        if (!data.uniqueCode) return false;
        return data.label.indexOf(value) !== -1 || data.uniqueCode.indexOf(value) !== -1
      } else {
        if (!value) return true;
        if (!data.label) return false;
        return data.label.indexOf(value) !== -1
      }
    },
    //格式化
    dateFormat(row, column) {
      let date = row[column.property];
      return this.$moment(date).format("YYYY年")
    },
    // 获取设备数据列表
    getDataList() {
      this.detaildialoglist = true;
      this.detaildialog = false;
      this.dataList = [];
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      //时间条件
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr
        this.dataForm.dateToStr = this.$moment(this.dataForm.dateFromStr).add(1, 'years').format("yyyy-MM-DD")
      } else {
        this.msg = "请选择时间";
        this.$message.warning(this.msg)
        return
      }
      //下拉框是否有选中
      if (this.value === '') {
        this.msg = this.labelNew
        this.$message.warning('请' + this.labelNew)
        loading.close();
        return
      }
      this.dateEnum = '5';
      //判断企业/区域/设备-查询，组装相应的查询条件
      if (this.type === -777) {
        this.deviceId = '';
        this.areaId = '';
        this.companyId = this.dataForm.companyId;
        // this.dateEnum = 3;
      } else if (this.type === -888) {
        this.companyId = '';
        this.deviceId = '';
        this.areaId = this.dataForm.areaId;
        // this.dateEnum = 3;
      } else if (this.type === -999) {
        this.companyId = '';
        this.areaId = '';
        this.deviceId = this.dataForm.deviceId;
        // this.dateEnum = 3;
      }
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/record/list'),
        method: 'get',
        params: this.$http.adornParams({
          'companyId': this.companyId,
          'deviceId': this.deviceId,
          'areaId': this.areaId,
          'dateFromStr': this.dataForm.dateFromStr,
          'dateToStr': this.dataForm.dateToStr,
          'dateEnum': this.dateEnum,
        })
      }).then(({data}) => {
        loading.close();
        if (data && data.code === 200) {
          this.isShow = true;
          this.isShowExcel = false;
          this.isiptShow = false;
          this.dataList = data.data;
          //重置参数
          this.dataForm.dateFromStr = '';
          this.dataForm.dateToStr = '';
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.msg = data.msg
        this.dataListLoading = false
      })
    },
    //导出excel
    tempExcel() {
      //下拉框是否有选中
      if (this.value === '') {
        this.msg = this.labelNew
        this.$message.warning('请' + this.labelNew)
        return
      }
      //时间条件
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr
        this.dataForm.dateToStr = this.$moment(this.dataForm.dateFromStr).add(1, 'years').format("yyyy-MM-DD")
      } else {
        this.msg = "请选择时间";
        this.$message.warning(this.msg)
        return
      }
      //这里的设备下拉框就是上面遍历的数据源
      // let obj = this.options.find((item) => {
      //   //筛选出匹配数据
      //   return item.value === this.value;
      // });
      const loading = this.$loading({
        lock: true,
        text: '导出中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      excel("/record/excel", this.value + "-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'companyId': this.companyId,
        'deviceId': this.deviceId,
        'areaId': this.areaId,
        'dateFromStr': this.dataForm.dateFromStr,
        'dateToStr': this.dataForm.dateToStr,
        'dateEnum': this.dateEnum,
      },loading.close(),this.$message({
          message: '导出成功',
          type: 'success',
          duration: 3000,
          showClose:true,
          onClose: () => {}
        })
      )
    },
    detailExcel(){
      //下拉框是否有选中
      if (this.value === '') {
        this.msg = this.labelNew
        this.$message.warning('请' + this.labelNew)
        return
      }
      //时间条件
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr
        this.dataForm.dateToStr = this.$moment(this.dataForm.dateFromStr).add(1, 'years').format("yyyy-MM-DD")
      } else {
        this.msg = "请选择时间";
        this.$message.warning(this.msg)
        return
      }
      excel("/record/detail/excel", this.value + "-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'deviceId': this.dcxq,
        'dateFromStr': this.dataForm.dateFromStr,
        'dateToStr': this.dataForm.dateToStr,
        'dateEnum': this.dateEnum,
      })
    },
    //合并
    arraySpanMethod({row, column, rowIndex, columnIndex}) {
      //合并所有行
      if (columnIndex < 2) {
        //只合并一次，一次合并1000行，后端传来的数据是根据企业分组的
        if (rowIndex === 0) {
          return {
            rowspan: 1000,
            colspan: 1
          };
        } else {
          //去掉其他的格子
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      //合并指定行数
      if (columnIndex === 7) {
        if (row.merge) {
          return {
            rowspan: row.merge,
            colspan: 1
          };
        } else {
          //去掉其他的格子
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      //合并指定行数
      if (columnIndex === 2) {
        if (row.merge) {
          return {
            rowspan: row.merge,
            colspan: 1
          };
        } else {
          //去掉其他的格子
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    //设备按钮
    deviceQuery() {
      this.isiptShow = false;
      this.buttonequip = 'primary';
      this.buttondayenterprise = '';
      this.buttonregion = '';
      //清空数据
      this.type = -999
      this.labelNew = "选择设备"
      this.value = ""
      this.msg = '请' + this.labelNew
      //设备下拉框
      this.hTree = JSON.parse(sessionStorage.getItem("hTree") || "[]");
    },
    arraySpanMethodnew({row, column, rowIndex, columnIndex}) {
      //合并所有行
      if (columnIndex < 2) {
        //只合并一次，一次合并1000行，后端传来的数据是根据企业分组的
        if (rowIndex === 0) {
          return {
            rowspan: 1000,
            colspan: 1
          };
        } else {
          //去掉其他的格子
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      //合并指定行数
      if (columnIndex === 1) {
        if (row.merge) {
          return {
            rowspan: row.merge,
            colspan: 1
          };
        } else {
          //去掉其他的格子
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    //企业按钮
    companyQuery() {
      this.isiptShow = false;
      this.buttondayenterprise = 'primary';
      this.buttonequip = '';
      this.buttonregion = '';
      this.type = -777
      this.labelNew = "选择企业"
      this.value = ""
      this.msg = '请' + this.labelNew
      this.$http({
        url: this.$http.adornUrl('/bigScreen/hierarchyTree/-777'),
        method: 'get',
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.hTree = data.data.hTree;
        }
      })
    },
    //区域按钮
    areaQuery() {
      this.isiptShow = false;
      this.buttonregion = 'primary';
      this.buttondayenterprise = '';
      this.buttonequip = ''
      this.type = -888
      this.labelNew = "选择区域"
      this.value = ""
      this.msg = '请' + this.labelNew
      this.$http({
        url: this.$http.adornUrl('/bigScreen/hierarchyTree/-888'),
        method: 'get',
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.hTree = data.data.hTree;
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog__body {
  height: calc(100% - 100px);
}

::-webkit-scrollbar-track {
  background-color: #ffffff;
}

.list-div {
  height: calc(100% - 100px);
  /* overflow-y: scroll; */
  clear: both;
}

.list-div .list-p {
  color: #333;
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.list-div .list-p .el-icon-warning {
  font-size: 50px;
  vertical-align: middle;
}

.el-tree {
  background: #eee;
  height: 300px;
  overflow-y: scroll;
  z-index: 9999;
  position: absolute;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/datacenter/yearRecord.vue